/* MAIYKO EKLENTI — "Bebeğini tulumda gör" (v23, 19 Eyl 2026)
   Delegasyonlu, tek kurulum. api_url boş → "çok yakında" mesajı; dolu → POST. Rıza: tek satır + dialog (v2).
   Fotoğraf tarayıcıda uzun kenar 1024 px'e küçültülüp JPEG olarak gönderilir; orijinal cihazdan çıkmaz. */
(function () {
  'use strict';
  if (window.__maiykoBebekTulumKurulu) return;
  window.__maiykoBebekTulumKurulu = true;

  var durum = {}; // kok id → {blob, desen, url}
  var SAKLA = 'maiyko_mbt_son';
  function cipUygula(kok, cip) {
    kok.querySelectorAll('.mbt__desen').forEach(function (c) { var on = c === cip; c.classList.toggle('is-secili', on); c.setAttribute('aria-checked', on ? 'true' : 'false'); });
    var st = d(kok); st.desen = cip.getAttribute('data-mbt-desen'); st.url = cip.getAttribute('data-url');
    kok.querySelectorAll('[data-mbt-desen-ad]').forEach(function (a) { a.textContent = cip.getAttribute('data-ad') || ''; });
    var img = cip.getAttribute('data-img'); if (img) kok.querySelectorAll('[data-mbt-mock],[data-mbt-mock2]').forEach(function (m) { m.style.backgroundImage = 'url(' + img + ')'; });
    var tf = kok.querySelector('[data-mbt-desen-tarif]'); if (tf) tf.textContent = cip.getAttribute('data-tarif') || '';
    var fy = kok.querySelector('[data-mbt-fiyat]'); if (fy) { var f1 = cip.getAttribute('data-fiyat') || '', e1 = cip.getAttribute('data-eski') || ''; fy.innerHTML = '<b>' + f1 + '</b>' + (e1 ? '<s>' + e1 + '</s>' : ''); }
  }
  function sonucGoster(kok, url, urunUrl, baslik, handle) {
    var sonuc = kok.querySelector('[data-mbt-sonuc]'), img = kok.querySelector('[data-mbt-sonuc-img]');
    if (img) img.src = url; if (sonuc) sonuc.hidden = false;
    if (handle) { var hc = kok.querySelector('.mbt__desen[data-mbt-desen="' + handle + '"]'); if (hc && !hc.classList.contains('is-secili')) cipUygula(kok, hc); bedenleriKur(kok, handle); }
    mailDurumu(kok); adimGoster(kok, 4);
    var b = kok.querySelector('[data-mbt-sonuc-baslik]'); if (b) { b.textContent = baslik || ''; b.hidden = !baslik; }
    kok.__mbtSonUrl = url;
  }
  function sonucSakla(url, desen, urunUrl) { try { localStorage.setItem(SAKLA, JSON.stringify({ url: url, desen: desen, urunUrl: urunUrl, zaman: Date.now() })); } catch (e) { /* yoksay */ } }
  function sonucGeriYukle() {
    document.querySelectorAll('[data-mbt]').forEach(function (kok) {
      if (kok.__mbtSonUrl) return;
      try { var s = JSON.parse(localStorage.getItem(SAKLA) || 'null'); if (!s || !s.url || Date.now() - s.zaman > 86400000) return; sonucGoster(kok, s.url, s.urunUrl, kok.getAttribute('data-son-baslik') || '', s.desen); } catch (e) { /* yoksay */ }
    });
  }
  function varyantlar(kok) {
    if (kok.__mbtVar) return kok.__mbtVar;
    var el = kok.querySelector('[data-mbt-varyantlar]'); try { kok.__mbtVar = JSON.parse(el ? el.textContent : '{}'); } catch (e) { kok.__mbtVar = {}; }
    return kok.__mbtVar;
  }
  function bedenleriKur(kok, handle) {
    var alan = kok.querySelector('[data-mbt-bedenler]'); if (!alan) return;
    var liste = varyantlar(kok)[handle] || []; var st = d(kok); st.varyant = null;
    alan.innerHTML = ''; var ad = kok.querySelector('[data-mbt-beden-ad]'); if (ad) ad.textContent = '';
    liste.forEach(function (v) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'mbt__beden-pil'; b.setAttribute('role', 'radio'); b.setAttribute('aria-checked', 'false');
      b.textContent = v.ad; b.dataset.varyant = v.id; if (!v.stok) b.disabled = true; alan.appendChild(b);
    });
    var sepet = kok.querySelector('[data-mbt-sepet]'); if (sepet) sepet.disabled = true;
    var sm = kok.querySelector('[data-mbt-sepet-mesaj]'); if (sm) { sm.hidden = true; sm.textContent = ''; }
  }
  function bedenSec(kok, pil) {
    kok.querySelectorAll('.mbt__beden-pil').forEach(function (p) { var on = p === pil; p.classList.toggle('is-secili', on); p.setAttribute('aria-checked', on ? 'true' : 'false'); });
    var st = d(kok); st.varyant = pil.dataset.varyant;
    var ad = kok.querySelector('[data-mbt-beden-ad]'); if (ad) ad.textContent = pil.textContent;
    var sepet = kok.querySelector('[data-mbt-sepet]'); if (sepet) sepet.disabled = false;
  }
  function sepeteEkle(kok, btn) {
    var st = d(kok); if (!st.varyant) return;
    sepeteEkleVaryant(kok, st.varyant, btn, kok.querySelector('[data-mbt-sepet-mesaj]'));
  }
  var MAILSAKLA = 'maiyko_mbt_mail';
  function mailDurumu(kok) {
    var alan = kok.querySelector('[data-mbt-mail]'); if (!alan) return;
    var ind = alan.querySelector('[data-mbt-indir]'); var gonderildi = false;
    try { gonderildi = !!localStorage.getItem(MAILSAKLA); } catch (e) { /* yoksay */ }
    alan.querySelectorAll('[data-mbt-eposta],[data-mbt-riza-mail],[data-mbt-mail-gonder],.mbt__mail-baslik,.mbt__riza--mail').forEach(function (el) { el.hidden = gonderildi; });
    if (ind) ind.hidden = !gonderildi;
    // Giriş yapmış müşteri: e-posta önceden dolu; pazarlama izni zaten varsa kutu işaretli gelir (tek dokunuşla gönder → indir)
    if (!gonderildi) {
      var me = kok.getAttribute('data-musteri-eposta'); var ep = alan.querySelector('[data-mbt-eposta]');
      if (me && ep && !ep.value) ep.value = me;
      var kutu = alan.querySelector('[data-mbt-riza-mail]'); if (kutu && kok.getAttribute('data-musteri-pazarlama') === '1' && !kutu.__mbtOn) { kutu.checked = true; kutu.__mbtOn = true; }
    }
  }
  function mailGonder(kok, btn) {
    var alan = kok.querySelector('[data-mbt-mail]'); if (!alan) return;
    var ep = (alan.querySelector('[data-mbt-eposta]').value || '').trim(); var kutu = alan.querySelector('[data-mbt-riza-mail]'); var mm = alan.querySelector('[data-mbt-mail-mesaj]');
    function m(t, hata) { if (!mm) return; mm.hidden = false; mm.textContent = t; mm.classList.toggle('is-hata', !!hata); }
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(ep)) { m('E-posta adresini kontrol et.', true); return; }
    if (!kutu || !kutu.checked) { m('Onay kutusunu işaretle.', true); return; }
    var api = (kok.getAttribute('data-api') || '').trim().replace(/\/uret\/?$/, '') + '/mail';
    var st = d(kok); btn.disabled = true;
    fetch(api, { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'include', body: JSON.stringify({ eposta: ep, gorsel: kok.__mbtSonUrl || '', desen: st.desen || '', riza_pazarlama: 1 }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (y) {
        if (!y.ok) { m((y.j && y.j.hata) || kok.getAttribute('data-mail-hata') || 'Gönderilemedi.', true); btn.disabled = false; return; }
        try { localStorage.setItem(MAILSAKLA, ep); } catch (e) { /* yoksay */ }
        m(y.j.gonderildi ? (kok.getAttribute('data-mail-gonderildi') || 'Gönderildi') : (kok.getAttribute('data-mail-kaydedildi') || 'Kaydedildi'), false);
        mailDurumu(kok); btn.disabled = false;
      })
      .catch(function () { m(kok.getAttribute('data-mail-hata') || 'Gönderilemedi.', true); btn.disabled = false; });
  }
  function adimGoster(kok, n) { kok.querySelectorAll('[data-mbt-adim]').forEach(function (a) { var k = parseInt(a.getAttribute('data-mbt-adim'), 10); a.classList.toggle('is-on', k === n); a.classList.toggle('is-ok', k < n); }); }
  function sepeteEkleVaryant(kok, varyant, btn, sm) {
    var eski = btn.textContent; btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(varyant, 10), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (y) {
        if (!y.ok) { throw new Error(y.j && (y.j.description || y.j.message) || 'sepet'); }
        var cd = document.querySelector('cart-drawer');
        if (cd && typeof cd.renderContents === 'function' && y.j.sections) { try { cd.renderContents(y.j); } catch (e) { window.location.href = '/cart'; } }
        else { window.location.href = '/cart'; }
        if (sm) { sm.hidden = false; sm.classList.remove('is-hata'); sm.textContent = kok.getAttribute('data-sepet-eklendi') || 'Sepete eklendi'; }
        btn.textContent = eski; btn.disabled = false;
      })
      .catch(function () { if (sm) { sm.hidden = false; sm.classList.add('is-hata'); sm.textContent = kok.getAttribute('data-sepet-hata') || 'Sepete eklenemedi.'; } btn.textContent = eski; btn.disabled = false; });
  }
  function kartlariKur() {
    var kartlar = document.querySelectorAll('[data-mbt-kk]'); if (!kartlar.length) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    setInterval(function () { kartlar.forEach(function (c) { if (c.matches(':hover')) return; c.classList.toggle('is-flip'); var n = c.querySelectorAll('.mbt__kk-nokta i'); if (n.length > 1) { n[0].classList.toggle('is-on', !c.classList.contains('is-flip')); n[1].classList.toggle('is-on', c.classList.contains('is-flip')); } }); }, 2800);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', kartlariKur); else kartlariKur();
  // ── Üretim hakkı (üye: sunucuda; ziyaretçi: tarayıcıda) ve puanla ek hak ──
  function anonimAnahtar(kok) { return 'maiyko_mbt_hak_' + (kok.getAttribute('data-donem') || 'donem'); }
  function hakUygula(kok, kalan, anonim) {
    var st = d(kok); st.hakYok = kalan <= 0;
    var hak = kok.querySelector('.mbt__hak'), puan = kok.querySelector('[data-mbt-puan]'), giris = kok.querySelector('[data-mbt-giris]');
    if (hak) {
      if (kalan > 0) { hak.textContent = (kok.getAttribute('data-hak-var') || '[n] hak').replace('[n]', kalan); hak.classList.remove('is-bitti'); }
      else { hak.textContent = anonim ? (kok.getAttribute('data-giris-gerekli') || 'Hakkın bitti.') : (kok.getAttribute('data-hak-bitti') || 'Hakkın bitti.'); hak.classList.add('is-bitti'); }
    }
    if (puan) puan.hidden = !(kalan <= 0 && !anonim);
    if (giris) giris.hidden = !(kalan <= 0 && anonim);
    butonGuncelle(kok);
  }
  function kimlikAl(kok) {
    var st = d(kok); if (st.kimlikAlindi) return; st.kimlikAlindi = true;
    if (kok.getAttribute('data-musteri') !== '1') {
      var kullanildi = false; try { kullanildi = localStorage.getItem(anonimAnahtar(kok)) === '1'; } catch (e) { /* yoksay */ }
      if (kullanildi) hakUygula(kok, 0, true);
      return;
    }
    var proxy = (kok.getAttribute('data-proxy') || '/apps/tulum').replace(/\/$/, '');
    fetch(proxy + '/kimlik', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (k) { if (k && k.giris && k.jeton) { st.jeton = k.jeton; hakUygula(kok, k.hak ? k.hak.kalan : 1, false); } })
      .catch(function () { /* kimlik alınamazsa ziyaretçi gibi devam */ });
  }
  function kimlikleriKur() { document.querySelectorAll('[data-mbt]').forEach(kimlikAl); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', kimlikleriKur); else kimlikleriKur();
  document.addEventListener('shopify:section:load', function () { setTimeout(kimlikleriKur, 60); });
  function puanIste(kok, btn) {
    var st = d(kok); if (!st.jeton) return;
    var api = (kok.getAttribute('data-api') || '').trim().replace(/\/uret\/?$/, '');
    btn.disabled = true; mesaj(kok, kok.getAttribute('data-bekle') || 'Bekle…');
    fetch(api + '/puan-iste', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ jeton: st.jeton }) })
      .then(function (r) { return r.json().then(function (x) { return { ok: r.ok, j: x }; }); })
      .then(function (y) {
        if (!y.ok) throw new Error((y.j && y.j.hata) || '');
        if (y.j.durum === 'hak_var') { hakUygula(kok, 1, false); mesaj(kok, ''); return; }
        var n = 0;
        (function sor() {
          setTimeout(function () {
            n++;
            fetch(api + '/puan-durum?jeton=' + encodeURIComponent(st.jeton), { cache: 'no-store' })
              .then(function (r) { return r.json(); })
              .then(function (x) {
                if (x.durum === 'verildi' || x.durum === 'hak_var') { hakUygula(kok, x.kalan || 1, false); mesaj(kok, kok.getAttribute('data-puan-dusuldu') || ''); btn.disabled = false; return; }
                if (x.durum === 'yetersiz') { mesaj(kok, kok.getAttribute('data-puan-yetersiz') || 'Puan yetersiz.', true); btn.disabled = false; return; }
                if (x.durum === 'zaman_asimi' || n >= 20) { mesaj(kok, kok.getAttribute('data-puan-gecikti') || 'Gecikti.', true); btn.disabled = false; return; }
                sor();
              })
              .catch(function () { if (n >= 20) { mesaj(kok, kok.getAttribute('data-puan-gecikti') || 'Gecikti.', true); btn.disabled = false; } else sor(); });
          }, 2000);
        })();
      })
      .catch(function (e) { mesaj(kok, (e && e.message) || kok.getAttribute('data-hata') || 'Olmadı.', true); btn.disabled = false; });
  }
  function indirBlob(blob) { var a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = 'maiyko-bebek-tulum.jpg'; document.body.appendChild(a); a.click(); setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 2000); }
  function indir(kok, btn) {
    var url = kok.__mbtSonUrl; if (!url) return;
    var eski = btn.textContent; btn.disabled = true;
    fetch(url, { mode: 'cors' }).then(function (r) { return r.blob(); }).then(function (blob) {
      var dosya = new File([blob], 'maiyko-bebek-tulum.jpg', { type: 'image/jpeg' });
      var mobil = /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
      if (mobil && navigator.canShare && navigator.canShare({ files: [dosya] })) { return navigator.share({ files: [dosya], title: 'Maiyko' }).catch(function () { indirBlob(blob); }); }
      indirBlob(blob);
    }).catch(function () { window.open(url, '_blank'); }).then(function () { btn.disabled = false; btn.textContent = eski; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sonucGeriYukle); else sonucGeriYukle();
  document.addEventListener('shopify:section:load', function () { setTimeout(sonucGeriYukle, 50); });

  function kokBul(el) { return el && el.closest ? el.closest('[data-mbt]') : null; }
  function d(kok) { var id = kok.id || 'mbt'; return durum[id] || (durum[id] = { blob: null, desen: null, url: null, jeton: null, hakYok: false, kimlikAlindi: false }); }
  function mesaj(kok, metin, hata) {
    var m = kok.querySelector('[data-mbt-mesaj]'); if (!m) return;
    m.textContent = metin || ''; m.hidden = !metin; m.classList.toggle('is-hata', !!hata);
  }
  function butonGuncelle(kok) {
    var st = d(kok), btn = kok.querySelector('[data-mbt-uret]'), riza = kok.querySelector('[data-mbt-riza]');
    if (btn) btn.disabled = !(st.blob && riza && riza.checked) || !!st.hakYok;
  }
  function seciliDesen(kok) {
    var st = d(kok);
    if (!st.desen) { var ilk = kok.querySelector('.mbt__desen.is-secili') || kok.querySelector('.mbt__desen'); if (ilk) { st.desen = ilk.getAttribute('data-mbt-desen'); st.url = ilk.getAttribute('data-url'); } }
    return st;
  }

  function kucult(file) {
    return new Promise(function (resolve) {
      var url = URL.createObjectURL(file), img = new Image();
      img.onload = function () {
        var max = 1024, w = img.naturalWidth, h = img.naturalHeight, k = Math.min(1, max / Math.max(w, h));
        var c = document.createElement('canvas'); c.width = Math.round(w * k); c.height = Math.round(h * k);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        c.toBlob(function (b) { URL.revokeObjectURL(url); resolve({ blob: b || file, onizleme: c.toDataURL('image/jpeg', 0.8) }); }, 'image/jpeg', 0.86);
      };
      img.onerror = function () { resolve({ blob: file, onizleme: url }); };
      img.src = url;
    });
  }

  document.addEventListener('click', function (e) {
    var cip = e.target.closest && e.target.closest('.mbt__desen');
    if (cip) {
      var kok = kokBul(cip); if (!kok) return;
      cipUygula(kok, cip);
      var sonucAcik = kok.querySelector('[data-mbt-sonuc]') && !kok.querySelector('[data-mbt-sonuc]').hidden; if (sonucAcik) bedenleriKur(kok, d(kok).desen);
      return;
    }
    var btn = e.target.closest && e.target.closest('[data-mbt-uret]');
    if (btn) { var k2 = kokBul(btn); if (k2) uret(k2, btn); return; }
    var pil = e.target.closest && e.target.closest('.mbt__beden-pil');
    if (pil && !pil.disabled) { var k8 = kokBul(pil); if (k8) bedenSec(k8, pil); return; }
    var pb = e.target.closest && e.target.closest('[data-mbt-puan]');
    if (pb && !pb.disabled) { var k12 = kokBul(pb); if (k12) puanIste(k12, pb); return; }
    var ks = e.target.closest && e.target.closest('[data-mbt-kart-sepet]');
    if (ks && !ks.disabled) { var k11 = kokBul(ks); var kk = ks.closest('[data-mbt-kk]'); var sel = kk && kk.querySelector('[data-mbt-kk-beden]'); if (k11 && sel && sel.value) sepeteEkleVaryant(k11, sel.value, ks, kk.querySelector('[data-mbt-kk-mesaj]')); return; }
    var sep = e.target.closest && e.target.closest('[data-mbt-sepet]');
    if (sep) { var k9 = kokBul(sep); if (k9) sepeteEkle(k9, sep); return; }
    var mg = e.target.closest && e.target.closest('[data-mbt-mail-gonder]');
    if (mg) { var k10 = kokBul(mg); if (k10) mailGonder(k10, mg); return; }
    var ind = e.target.closest && e.target.closest('[data-mbt-indir]');
    if (ind) { var k7 = kokBul(ind); if (k7) indir(k7, ind); return; }
    var ac = e.target.closest && e.target.closest('[data-mbt-sartlar-ac]');
    if (ac) { var k4 = kokBul(ac); if (k4) dialogAc(k4); return; }
    var kabul = e.target.closest && e.target.closest('[data-mbt-sartlar-kabul]');
    if (kabul) { var k5 = kokBul(kabul); if (k5) { var r5 = k5.querySelector('[data-mbt-riza]'); if (r5) r5.checked = true; butonGuncelle(k5); dialogKapat(k5); } return; }
    var kapat = e.target.closest && e.target.closest('[data-mbt-sartlar-kapat]');
    if (kapat) { var k6 = kokBul(kapat); if (k6) dialogKapat(k6); return; }
    var dlg = e.target.closest && e.target.closest('[data-mbt-dialog]');
    if (dlg && e.target === dlg) { dialogKapatEl(dlg); }
  });

  function dialogAc(kok) { var d = kok.querySelector('[data-mbt-dialog]'); if (!d) return; if (typeof d.showModal === 'function') { try { d.showModal(); return; } catch (e) { /* yoksay */ } } d.setAttribute('open', ''); }
  function dialogKapatEl(d) { if (!d) return; if (typeof d.close === 'function') { try { d.close(); return; } catch (e) { /* yoksay */ } } d.removeAttribute('open'); }
  function dialogKapat(kok) { dialogKapatEl(kok.querySelector('[data-mbt-dialog]')); }

  document.addEventListener('change', function (e) {
    var foto = e.target.closest && e.target.closest('[data-mbt-foto]');
    if (foto) {
      var kok = kokBul(foto); if (!kok) return;
      var f = foto.files && foto.files[0]; if (!f) return;
      kucult(f).then(function (r) {
        var st = d(kok); st.blob = r.blob;
        var alan = kok.querySelector('[data-mbt-yukle]');
        if (alan) {
          alan.classList.add('is-dolu');
          var eski = alan.querySelector('img'); if (eski) eski.remove();
          var im = document.createElement('img'); im.src = r.onizleme; im.alt = 'Yüklenen fotoğraf';
          var ik = alan.querySelector('.mbt__yukle-ik'); if (ik) { ik.hidden = true; alan.insertBefore(im, ik); } else alan.prepend(im);
          var b = alan.querySelector('[data-mbt-yukle-baslik]'); if (b) b.textContent = 'Fotoğraf hazır';
          var a = alan.querySelector('[data-mbt-yukle-alt]'); if (a) a.textContent = 'Değiştirmek için dokun.';
        }
        mesaj(kok, '');
        butonGuncelle(kok);
        var ua = kok.querySelector('[data-mbt-uret-alan]'); if (ua) ua.hidden = false; adimGoster(kok, 2);
      });
      return;
    }
    var kb = e.target.closest && e.target.closest('[data-mbt-kk-beden]');
    if (kb) { var kkb = kb.closest('[data-mbt-kk]'); var kbt = kkb && kkb.querySelector('[data-mbt-kart-sepet]'); if (kbt) kbt.disabled = !kb.value; return; }
    var riza = e.target.closest && e.target.closest('[data-mbt-riza]');
    if (riza) { var k3 = kokBul(riza); if (k3) { butonGuncelle(k3); if (riza.checked) adimGoster(k3, 3); } }
  });

  function blobBase64(blob) { return new Promise(function (res, rej) { var r = new FileReader(); r.onload = function () { res(String(r.result).split(',')[1] || ''); }; r.onerror = rej; r.readAsDataURL(blob); }); }
  // Üretim: gönder → iş numarası → 3 sn'de bir sor (uzun HTTP isteği yok; ağ takılsa sonuç kaybolmaz).
  // Eski eşzamanlı sunucu {gorsel_url} dönerse o da kabul edilir.
  function uret(kok, btn) {
    var st = seciliDesen(kok);
    var api = (kok.getAttribute('data-api') || '').trim();
    if (!/^https:\/\/[^\s\/]+\.[^\s]+/.test(api)) { mesaj(kok, kok.getAttribute('data-yakinda') || 'Çok yakında.'); return; }
    if (!st.blob) return;
    btn.disabled = true; mesaj(kok, kok.getAttribute('data-bekle') || 'Hazırlanıyor…');
    var taban = api.replace(/\/uret\/?$/, '');
    var bitti = false;
    function hata(m) { if (bitti) return; bitti = true; mesaj(kok, m || kok.getAttribute('data-hata') || 'Şu an üretemedik.', true); btn.disabled = false; }
    blobBase64(st.blob)
      .then(function (b64) {
        return fetch(api, { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'include',
          body: JSON.stringify({ foto: b64, urun: kok.getAttribute('data-urun') || '', desen: st.desen || '', riza: '1', kaynak: 'shopify', jeton: st.jeton || undefined }) });
      })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (y) {
        var j = y.j || {};
        if (!y.ok || j.hata) { if (j.kod === 'HAK_YOK') hakUygula(kok, 0, !st.jeton); throw new Error(j.hata || ''); }
        if (j.gorsel_url) return j;
        if (!j.is_id) throw new Error('');
        return new Promise(function (res, rej) {
          var n = 0;
          (function sor() {
            setTimeout(function () {
              n++;
              fetch(taban + '/is/' + encodeURIComponent(j.is_id), { credentials: 'include', cache: 'no-store' })
                .then(function (r) { return r.json(); })
                .then(function (d) {
                  if (d.durum === 'hazir' && d.gorsel_url) return res(d);
                  if (d.durum === 'hata') return rej(new Error(d.hata || ''));
                  if (n >= 60) return rej(new Error(''));
                  sor();
                })
                .catch(function () { if (n >= 60) rej(new Error('')); else sor(); });
            }, 3000);
          })();
        });
      })
      .then(function (j) {
        bitti = true;
        sonucGoster(kok, j.gorsel_url, st.url, '', st.desen);
        sonucSakla(j.gorsel_url, st.desen, st.url);
        var sonuc = kok.querySelector('[data-mbt-sonuc]');
        mesaj(kok, '');
        if (st.jeton) { if (typeof j.kalan_hak !== 'undefined' && j.kalan_hak !== null) hakUygula(kok, j.kalan_hak, false); }
        else { try { localStorage.setItem(anonimAnahtar(kok), '1'); } catch (e) { /* yoksay */ } hakUygula(kok, 0, true); }
        try { sonuc.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { /* yoksay */ }
      })
      .catch(function (e) { hata(e && e.message); });
  }
})();
